const readWith = <T extends ArrayBuffer | string>(
  blob: Blob,
  read: (reader: FileReader) => void
): Promise<T> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result as T);
    reader.onerror = () => reject(reader.error);
    read(reader);
  });

export const blobToArrayBuffer = (blob: Blob): Promise<ArrayBuffer> => {
  if (typeof blob.arrayBuffer === 'function') {
    return blob.arrayBuffer();
  }

  return readWith<ArrayBuffer>(blob, (reader) => reader.readAsArrayBuffer(blob));
};

export const blobToText = (blob: Blob): Promise<string> => {
  if (typeof blob.text === 'function') {
    return blob.text();
  }

  return readWith<string>(blob, (reader) => reader.readAsText(blob));
};
